// import fileDownload from "js-file-download";
import { message } from 'antd';

import axios from 'util/axiosConfig';

export const getHL7ReceivedMessagesAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/get-received-hl7-message`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const downloadHL7ReceivedMessage = async (id) => {
    return await axios.get(`/api/v1/admin/hl7-received-message`, {
        params: {
            id
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                const fileName = id + '.hl7';
                // fileDownload(response.data, fileName);
            } else {
                message.error('Failed to download file!');
            }
        })
        .catch(function (error) {
            message.error('Failed to download file!');
        });
}